import React from "react";
import ContactRow1 from "./ContactRow1";
import ContactRow2 from "./ContactRow2";

const ContactPage = () => {
  return (
    <div style={{ width: "100%", overflow: "hidden", margin: 0, padding: 0 }}>
      <ContactRow1 />
      {/* <ContactRow2 /> */}
    </div>
  );
};

export default ContactPage;
